import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import SimpleModal from '../../../components/base/SimpleModal';
import css from './style.scss';

const RemovePropertyConfirmModal = ({ onConfirm, onCancel }) =>
  ReactDOM.createPortal(
    <SimpleModal
      isOpen
      uniqueId="remove-property-confirm-modal"
      title="Confirm Property Removal"
      onCancel={onCancel}
      modalFooterWrapperClassName={css.customFooterWrapper}
      modalClassName={classNames(css.deleteListConfirmModal, css.customPropertyClass)}
      customFooter={
        <div className={css.customFooter}>
          <div className={css.modalDescription}>
            Are you sure you want to remove the selected property from this list?
          </div>
          <div className={css.modalWarning}>
            Notice: Deleting properties does not provide access to more Saves. Access the Account
            section to increase the Save limit.
          </div>
          <div className={css.buttonGroup}>
            <button className={css.cancelSecondary} onClick={onCancel}>
              Cancel
            </button>
            <button className={css.dangerBtn} onClick={onConfirm}>
              Remove
            </button>
          </div>
        </div>
      }
    />,
    document.body
  );

export default RemovePropertyConfirmModal;
